import {
  DashboardOverviewResponse,
  DashboardPartnerTrackingResponse,
} from '../models/dashboard-api';
import { DashboardLayoutConfig } from '../models/dashboard-config';

export interface DashboardState {
  layout: DashboardLayoutConfig | null;
  overview: DashboardOverviewResponse | null;
  tracking: DashboardPartnerTrackingResponse | null;
  overviewLoading: boolean;
  trackingLoading: boolean;
  overviewError: string | null;
  trackingError: string | null;
}

export const initialDashboardState: DashboardState = {
  layout: null,
  overview: null,
  tracking: null,
  overviewLoading: false,
  trackingLoading: false,
  overviewError: null,
  trackingError: null,
};
